import { isEmpty } from "lodash-es";
import * as z from "zod/v4-mini";

export const redirectSchema = z.pipe(
  z.xor([
    z.object({
      redirectTarget: z.literal("participationRequest"),
      canvassId: z.uuidv4(),
    }),
    z.strictObject({}),
  ]),
  z.transform((redirect) => (strictIsEmpty(redirect) ? undefined : redirect)),
);

function strictIsEmpty(obj: object): obj is Record<string, never> {
  return isEmpty(obj);
}
